var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.482 9.49695C18.0399 8.24174 16.7573 6.95915 15.5021 7.51703L10.5018 9.73937C10.1625 9.89019 9.89118 10.1615 9.74036 10.5008L7.51801 15.5011C6.96014 16.7563 8.24272 18.0389 9.49794 17.481L14.4982 15.2587C14.8375 15.1079 15.1089 14.8365 15.2597 14.4972L17.482 9.49695ZM11.4898 11.4888L15.1264 9.87263L13.5102 13.5092L9.87362 15.1254L11.4898 11.4888Z",
    fill: "#FF6741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 23.5C18.5751 23.5 23.5 18.5751 23.5 12.5C23.5 6.42487 18.5751 1.5 12.5 1.5C6.42487 1.5 1.5 6.42487 1.5 12.5C1.5 18.5751 6.42487 23.5 12.5 23.5ZM12.5 21.4869C7.53665 21.4869 3.51306 17.4633 3.51306 12.5C3.51306 7.53665 7.53665 3.51306 12.5 3.51306C17.4633 3.51306 21.4869 7.53665 21.4869 12.5C21.4869 17.4633 17.4633 21.4869 12.5 21.4869Z",
    fill: "#FF6741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverActive);
export default __webpack_public_path__ + "static/media/discover_active.0b03bfbaaf670a1b8742ee9427570bc3.svg";
export { ForwardRef as ReactComponent };